module.exports = __webpack_public_path__ + "static/l2-service-img2-897611df6984395e471ba701861a7e30.jpg";